<template>
  <div class="result-box" :class="{video: isVideoOrAudio(item)}">
    <!-- THUMB -->
    <div class="thumb-box thumb-272">
      <div class="clip">
        <img
          v-if="item.thumb"
          :src="item.thumb"
          class="thumb"
          :alt="item.meta?.title"
          @error="$event.target.remove()"
        />
        <span v-if="isVideoOrAudio(item)" class="play-btn"></span>
      </div>
    </div>

    <!-- INFO -->
    <div class="info-box">
      <div class="meta">
        <div class="row title" :title="item.meta?.title">
          {{ item.meta?.title }}
        </div>
        <div class="row duration" :title="item.meta?.duration">
          {{ item.meta?.duration }}
        </div>
      </div>

      <!-- LINKS -->
      <div
        class="link-box"
        :class="{ expand: isExpanded, showall: showAll }"
        ref="dropdown"
      >
        <!-- BEST FORMAT -->
        <div class="def-btn-box" v-if="bestFormat">
          <a
            target="_blank"
            :href="bestFormat.url"
            rel="noreferrer"
            class="link subname"
            :class="{
                'no-audio': bestFormat.no_audio,
                'no-downloadable': bestFormat.downloadable === false
              }"
            @click="handleDownload(bestFormat, $event)"
          >
            {{ sortedFormats.length === 1 ? `Unduh ${bestFormat.ext}` : 'Unduh' }}
          </a>
        </div>

        <!-- DROPDOWN -->
        <div class="drop-down-box" v-if="sortedFormats.length > 1">
          <div
            class="def-btn-name"
            style="cursor:pointer"
            @click="toggleDropdown"
          >
            {{ bestFormat.name }}
            <span v-if="bestFormat.subname" class="subname">
                {{ bestFormat.subname }}
              </span>
          </div>

          <div class="list" v-show="isExpanded">
            <div class="links">
              <div class="main">
                <!-- MAIN FORMATS -->
                <div class="link-group">
                  <a
                    v-for="(format, i) in mainFormats"
                    :key="'main-' + i"
                    target="_blank"
                    :href="format.url"
                    rel="noreferrer"
                    class="link subname"
                    :class="{
                        'no-audio': format.no_audio,
                        'no-downloadable': format.downloadable === false
                      }"
                    @click="handleDownload(format, $event)"
                  >
                    {{ format.name }}
                    <span v-if="format.subname" class="subname">
                        {{ format.subname }}
                      </span>
                  </a>
                </div>

                <!-- EXTRA FORMATS -->
                <div class="link-group" v-if="showAll">
                  <a
                    v-for="(format, i) in extraFormats"
                    :key="'extra-' + i"
                    target="_blank"
                    :href="format.url"
                    rel="noreferrer"
                    class="link subname"
                    :class="{
                        'no-audio': format.no_audio,
                        'no-downloadable': format.downloadable === false
                      }"
                    @click="handleDownload(format, $event)"
                  >
                    {{ format.name }}
                    <span v-if="format.subname" class="subname">
                        {{ format.subname }}
                      </span>
                  </a>
                </div>
              </div>

              <!-- MORE -->
              <div class="more-links" v-if="sortedFormats.length > 5">
                <a href="#" class="tracked" :class="{rotate: showAll}" @click.prevent="toggleMore">
                  {{ showAll ? 'Lainnya' : 'Lainnya' }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {handleFormatDownload} from "../tools/downloadFormat";
import {sortFormats} from "../tools/sortFormats";
import {formatSortConfig} from "../tools/formatSortConfig";

export default {
  name: 'ItemResultDefault',
  props: {
    item: {
      type: Object,
      required: true
    },
    domainName: String,
    // event_label события download_click ('playlist' у видео плейлиста, PlaylistCard.vue)
    eventLabel: String
  },
  data() {
    return {
      isExpanded: false,
      showAll: false
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  computed: {
    formats() {
      return this.item.url || []
    },

    sortedFormats() {
      return sortFormats(this.formats)
    },

    bestFormat() {
      return this.sortedFormats[0]
    },

    mainFormats() {
      return this.sortedFormats.slice(0, 5)
    },

    extraFormats() {
      return this.sortedFormats.slice(5)
    }
  },
  methods: {
    toggleDropdown() {
      this.isExpanded = !this.isExpanded
    },
    toggleMore() {
      this.showAll = !this.showAll
    },
    handleClickOutside(e) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(e.target)) {
        this.isExpanded = false
      }
    },
    isVideoOrAudio(item) {
      return item.url.some(format => {
        const ext = format?.type?.toLowerCase() || format?.ext?.toLowerCase();
        return formatSortConfig.video.includes(ext) || formatSortConfig.audio.includes(ext);
      });
    },
    handleDownload(format, e) {
      handleFormatDownload(this, format, e, this.eventLabel)
    },
  }
}
</script>
